import { GET_PENDING_INVOICES_SUCCESS } from '../constants/actionTypes';

const INITIAL_STATE = { pendingInvoices: [], errors: null };

export default function getUnPaidInvoices(state=INITIAL_STATE, action) {
  
  switch(action.type) {
    case GET_PENDING_INVOICES_SUCCESS:
      
      
      return { ...state, pendingInvoices: action.payload.data, errors: null }
    default:
      return state;
  }
}